<template>
  <div>
    <!--loading-->
    <div :class="LoadShow == true && desktopStatus == false && ishd != 1 ?'Aloading':'Aloading LoadNone'">
      <img src="static/images/loading.gif" />
      <p>数据努力加载中，请稍等...</p>
    </div>
    <div :class="LoadShow == false ? 'conent':'conent LoadNone'" style="min-width: 1024px;overflow-x: hidden;">
      <div v-if="desktopStatus == false" class="left" :class="isCollapse ? 'menuWidth1' : 'menuWidth2'" :style="height">
        <yz-menu :menus-list="menusList" :menu-index="menuIndex" :shop-img="shopImg" :is-collapse="isCollapse" :desktop-status="desktopStatus"></yz-menu>
      </div>
      <div v-else class="left menuWidth2 desktopLeft" :style="height">
        <yz-menu :menus-list="menusList" :menu-index="menuIndex" :shop-img="shopImg" :is-collapse="isCollapse" :desktop-status="desktopStatus"></yz-menu>
      </div>
      <div class="right" :class="isCollapse ? 'menuPL1' : 'menuPL2'" :style="height">
        <div id="yzTop" class="top">
          <div v-if="deadlineStatus == true" class="deadline">
            <div class="d_left">
              <p>您的账号还剩余{{ form.days }}天的有效期就到期，若逾期未续费套餐将停止使用，到时将影响您的正常运营；</p>
              <p>
                官方咨询电话：400 889 4522
                <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2853821200&site=qq&menu=yes">在线咨询：小多（唤起对话）</a>
              </p>
            </div>
            <div class="d_right">
              <el-button type="primary" style="margin-left: 30px;" @click="jumpRenew">立即续费</el-button>
            </div>
            <!-- <i class="el-icon-close" @click="changeDls"></i> -->
          </div>
          <yz-top :menus-list="menusList" :store-list="storeList" :store-id="storeId" :shop-img="shopImg" :account="account" :account-name="accountName" :logo-url="logoUrl" :erp-type="erpType" :show-buletin="showBuletin" :bulletin-num="bulletinNum" :comment-num="commentNum" :desktop-status="desktopStatus" @lookBulletinBoard="lookBulletinBoard" @lookCommentList="lookCommentList" @startLoadData="startLoadData"></yz-top>
        </div>
        <div :class="isCollapse ? 'right-content2' : 'right-content'" :style="contentHeight">
          <keep-alive>
            <router-view v-if="isRouterAlice" />
          </keep-alive>
        </div>
        <gt-deadlineDig @deadlineData="getDeadlineData">详情</gt-deadlineDig>
      </div>
      <div id="enlarge" class="enlargeModel" @click="Lib.enlarge()">
        <div class="container">
          <img src />
        </div>
      </div>
    </div>
    <div id="couponMask" style="display: none;"><div class="maskOne"></div><div class="maskTwo"></div><div class="maskThree"></div></div>
  </div>
</template>
<script>
import YzMenu from './template/menu.vue';
import YzTop from './template/top.vue';
import {
  getSignSuccess, getChangeStore, getAccountMsg
} from './api';

export default {
  components: {
    YzMenu,
    YzTop
  },
  data() {
    return {
      height: {
        height: '500px'
      },
      width: {
        width: '100%'
      },
      contentHeight: {},
      minHeight: {
        minHeight: '500px'
      },
      storeList: [], // 店铺列表
      storeId: '', // 店铺ID
      menusList: [
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        },
        {
          menus_name: '',
          icon: ''
        }
      ], // 菜单列表
      menuIndex: '前台', // 第一菜单
      shopImg: '', // 店铺图片
      account: '', // 商家账号
      accountName: '', // 商家账号名称
      isCollapse: false, // 展开和收起
      screenWidth: document.body.clientWidth, // 屏幕宽度
      logoUrl: '',
      erpType: '',
      deadlineStatus: false,
      form: {
        diglogStatus: false,
        url: '',
        days: ''
      },
      showBuletin: true,
      bulletinNum: 0,
      commentNum: 0,
      desktopStatus: false, // 判断是否是桌面端
      LoadShow: true, // 判断数据加载完成
      isRouterAlice: true,
      ishd: window.sessionStorage.ishd ? 1 : 0, // 判断是否是HD  0不是  1是
    };
  },
  watch: {
    $route(e, from) {
      window.sessionStorage.stopTime = new Date().getTime() * 1 - (window.sessionStorage.recordTime ? (window.sessionStorage.recordTime * 1) : 0);
      window.sessionStorage.recordTime = new Date().getTime();
      $('.right-content').animate({
        scrollTop: '0'
      }, 0);
      const { name } = e;
      if (e.name == 'stage-index' || name == 'stage-coupon') {
        this.menuIndex = '前台';
      }
      if (name == 'service-all' || name == 'credit-index' || name == 'stage-cashBox') {
        this.menuIndex = '订单';
      }
      if (name == 'stage-allDay' || name == 'stage-bespeakService' || name == 'stage-bespeakTechnician') {
        this.menuIndex = '预约';
      }
      if (name == 'customer-index') {
        this.menuIndex = '顾客';
      }
      if (name == 'finance-income' || name == 'achivement-index' || name == 'booking-index' || name == 'package-overview' || name == 'analyse-index' || name == 'project-analysis') {
        this.menuIndex = '4-1';
      }
      if (name == 'achivement-index') {
        this.menuIndex = '4-2';
      }
      if (name == 'booking-index') {
        this.menuIndex = '4-3';
      }
      if (name == 'analyse-index') {
        this.menuIndex = '4-4';
      }
      if (name == 'package-overview') {
        this.menuIndex = '4-5';
      }
      if (name == 'project-analysis') {
        this.menuIndex = '4-6';
      }
      if (name == 'stage-attendance' || name == 'attendance-record' || name == 'stage-setScheduling') {
        this.menuIndex = '出勤';
      }
      // 下面判断是否关闭套餐办理，对应清掉输入的值
      if (from.name == 'stage-setMeal') {
        const list = JSON.parse(window.sessionStorage.yzTableList);
        let tCount = 0;
        list.editableTabs2.forEach((a) => {
          if (a.name != 'stage-setMeal') {
            tCount++;
          }
        });
        if (tCount == list.editableTabs2.length) {
          window.sessionStorage.rechargePhone = '';
        }
      }
      window.sessionStorage.menuIndex = this.menuIndex;
    },
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        const vm = this;
        setTimeout(() => {
          vm.onresize();
          vm.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    const vm = this;
    if (this.$isDesktop() === true) {
      window.sessionStorage.isDesktop = 1;
    } else {
      window.sessionStorage.isDesktop = 0;
    }
    window.onresize = () => {
      vm.onresize();
      return (() => {
        window.screenWidth = document.body.clientWidth;
        vm.screenWidth = window.screenWidth;
      })();
    };
    this.onresize();
    this.menuIndex = window.sessionStorage.menuIndex || '前台';
    // this.menuIndex = "前台";
    if (window.require !== undefined) {
      this.desktopStatus = true;
    } else if (window.sessionStorage.ishd == 1) {
      this.desktopStatus = true;
    } else {
      this.desktopStatus = false;
    }
    // const list = JSON.parse(sessionStorage.getItem('menusList'));
    // let menusCount = 0;
    // list.forEach((a) => {
    //   if (window.location.href.indexOf(a.url) > -1) {
    //     menusCount = 1;
    //   }
    // });
    // if (menusCount == 0) {
    //   this.$router.push({
    //     name: 'stage-index'
    //   });
    // }
  },
  beforeCreate() {
    window.sessionStorage.mdSign = 'beauty';
    getSignSuccess().then((res) => {
      if (res.code == 0) {
        res.data.erpType == 1
          ? (document.title = (res.data.ccMsData.websiteTitle || '多粉美业版'))
          : (document.title = '多粉美业版');
        res.data.ccMsData
          ? res.data.ccMsData.logoUrl
            ? (document.getElementById('webIcon').href = res.data.ccMsData.logoUrl)
            : (document.getElementById('webIcon').href = 'static/images/favicon.ico')
          : (document.getElementById('webIcon').href = 'static/images/favicon.ico');
        res.data.ccMsData
          ? res.data.ccMsData.logoUrl
            ? (document.getElementById('shortcutIcon').href = res.data.ccMsData.logoUrl)
            : (document.getElementById('shortcutIcon').href = 'static/images/favicon.ico')
          : (document.getElementById('shortcutIcon').href = 'static/images/favicon.ico');
        if (!window.sessionStorage.yzTableList && !window.sessionStorage.previousRecord) {
          const tabDetail = {
            editableTabs2: [
              {
                title: '前台',
                name: 'stage-index'
              }
            ],
            tabIndex: 'stage-index'
          };
          window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
          window.sessionStorage.previousRecord = window.JSON.stringify(tabDetail.editableTabs2);
        }
        if (res.data.status == 111 || res.data.status == 222) {
          window.sessionStorage.setUrlStatus = 1;
          this.$router.push({
            name: 'stage-index'
          });
          const tabDetail = {
            editableTabs2: [
              {
                title: '前台',
                name: 'stage-index'
              }
            ],
            tabIndex: 'stage-index'
          };
          window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
          window.sessionStorage.previousRecord = window.JSON.stringify(tabDetail.editableTabs2);
          this.LoadShow = false;
          return;
        }
        window.sessionStorage.setUrlStatus = 2;
        window.sessionStorage.isHidePhone = res.data.isHidePhone;
        this.menusList = res.data.menusList;

        sessionStorage.setItem('menusList', JSON.stringify(res.data.menusList));
        const isArtiContro = res.data.menusList.findIndex((x) => x.menus_name === '公告管理');
        if (isArtiContro === -1) {
          this.showBuletin = false;
        }
        this.erpType = res.data.erpType;
        this.logoUrl = res.data.ccMsData
          ? res.data.ccMsData.logoUrl
          : 'static/images/yangzi.png';
        this.storeList = res.data.storeList;
        const sArr = [];
        res.data.storeList.forEach((c) => {
          const sobj = {};
          sobj.shopName = c.shopName;
          sobj.id = c.shopId;
          sArr.push(sobj);
        });
        sessionStorage.setItem('storeList', JSON.stringify(sArr));

        this.storeId = res.data.storeId;
        this.shopImg = res.data.logoUrl
          ? res.data.logoUrl
          : 'static/images/yangzi.png';
        this.account = res.data.logoAccounts;
        this.accountName = res.data.loginName;
        window.busId = res.data.storeId;
        sessionStorage.setItem('busId', res.data.selectMain.busId);
        let isListNum = 0;
        window.sessionStorage.loginType = res.data.loginType;
        if (res.data.storeList.length > 0) {
          res.data.storeList.forEach((item) => {
            if (res.data.storeId == item.id) {
              window.sessionStorage.shopValue = item.shopName;
            } else {
              isListNum++;
            }
          });
          if (isListNum == res.data.storeList.length) {
            window.sessionStorage.shopValue = res.data.storeList[0].shopName;
            res.data.storeId = res.data.storeList[0].id;
            getChangeStore({
              storeId: res.data.storeId
            }).then((resTwo) => {
              if (resTwo.code == 0) {
                setTimeout(() => {
                  Object.assign(
                    this.$data,
                    this.$options.data()
                  );
                  window.history.go(0);
                }, 100);
              }
            });
          }
        }
        // 获取mainId
        this.$store.commit('getMainId', res.data.storeId ? res.data.storeId : 0);
        window.sessionStorage.setUrl = res.data.setUrl ? res.data.setUrl : 0;
        window.sessionStorage.mainId = res.data.storeId ? res.data.storeId : 0;
        window.sessionStorage.shopId = res.data.selectMain.shopId || 0;
        window.sessionStorage.setUrl4Print = res.data.setUrl4Print;
        window.sessionStorage.setUrl4Pay = res.data.setUrl4Pay;
        window.sessionStorage.setUrl4Shop = res.data.setUrl4Shop;
        window.sessionStorage.tidyStatus = res.data.selectMain.roomType;
        this.LoadShow = false;
      } else {
        this.$store.commit('getMainId', 0);
        window.sessionStorage.setUrl = 0;
        window.sessionStorage.mainId = 0;
        window.sessionStorage.shopId = 0;
      }
      // if (this.desktopStatus == true && window.sessionStorage.ishd != 1) {
      //   window.dfPcDesltop.finisLoad(); // 关闭loading效果
      // }
      window.sessionStorage.newKey = 1;
      this.getBusinessInfo();
    });
  },
  methods: {
    // 初始化
    startLoadData() {
      getSignSuccess().then((res) => {
        if (res.code == 0) {
          res.data.erpType == 1
            ? (document.title = (res.data.ccMsData.websiteTitle || '多粉美业版'))
            : (document.title = '多粉美业版');
          res.data.ccMsData
            ? res.data.ccMsData.logoUrl
              ? (document.getElementById('webIcon').href = res.data.ccMsData.logoUrl)
              : (document.getElementById('webIcon').href = 'static/images/favicon.ico')
            : (document.getElementById('webIcon').href = 'static/images/favicon.ico');
          res.data.ccMsData
            ? res.data.ccMsData.logoUrl
              ? (document.getElementById('shortcutIcon').href = res.data.ccMsData.logoUrl)
              : (document.getElementById('shortcutIcon').href = 'static/images/favicon.ico')
            : (document.getElementById('shortcutIcon').href = 'static/images/favicon.ico');
          if (res.data.status == 111 || res.data.status == 222) {
            window.sessionStorage.setUrlStatus = 1;
            this.$router.push({
              name: 'stage-index'
            });
            const tabDetail = {
              editableTabs2: [
                {
                  title: '前台',
                  name: 'stage-index'
                }
              ],
              tabIndex: 'stage-index'
            };
            window.sessionStorage.yzTableList = window.JSON.stringify(tabDetail);
            window.sessionStorage.previousRecord = window.JSON.stringify(tabDetail.editableTabs2);
            return;
          }
          window.sessionStorage.setUrlStatus = 2;
          window.sessionStorage.isHidePhone = res.data.isHidePhone;
          this.menusList = res.data.menusList;

          sessionStorage.setItem('menusList', JSON.stringify(res.data.menusList));
          const isArtiContro = res.data.menusList.findIndex((x) => x.menus_name === '公告管理');
          if (isArtiContro === -1) {
            this.showBuletin = false;
          }
          this.erpType = res.data.erpType;
          this.logoUrl = res.data.ccMsData
            ? res.data.ccMsData.logoUrl
            : 'static/images/yangzi.png';
          this.storeList = res.data.storeList;

          this.storeId = res.data.storeId;
          this.shopImg = res.data.logoUrl
            ? res.data.logoUrl
            : 'static/images/yangzi.png';
          this.account = res.data.logoAccounts;
          this.accountName = res.data.loginName;
          window.busId = res.data.storeId;
          sessionStorage.setItem('busId', res.data.selectMain.busId);
          let isListNum = 0;
          window.sessionStorage.loginType = res.data.loginType;
          if (res.data.storeList.length > 0) {
            res.data.storeList.forEach((item) => {
              if (res.data.storeId == item.id) {
                window.sessionStorage.shopValue = item.shopName;
              } else {
                isListNum++;
              }
            });
            if (isListNum == res.data.storeList.length) {
              window.sessionStorage.shopValue = res.data.storeList[0].shopName;
              res.data.storeId = res.data.storeList[0].id;
              getChangeStore({
                storeId: res.data.storeId
              }).then((resTwo) => {
                if (resTwo.code == 0) {
                  setTimeout(() => {
                    Object.assign(
                      this.$data,
                      this.$options.data()
                    );
                    window.history.go(0);
                  }, 100);
                }
              });
            }
          }
          // 获取mainId
          this.$store.commit('getMainId', res.data.storeId ? res.data.storeId : 0);
          window.sessionStorage.setUrl = res.data.setUrl ? res.data.setUrl : 0;
          window.sessionStorage.mainId = res.data.storeId ? res.data.storeId : 0;
          window.sessionStorage.shopId = res.data.selectMain.shopId || 0;
          window.sessionStorage.setUrl4Print = res.data.setUrl4Print;
          window.sessionStorage.setUrl4Pay = res.data.setUrl4Pay;
          window.sessionStorage.setUrl4Shop = res.data.setUrl4Shop;
          this.LoadShow = false;
        } else {
          this.$store.commit('getMainId', 0);
          window.sessionStorage.setUrl = 0;
          window.sessionStorage.mainId = 0;
          window.sessionStorage.shopId = 0;
        }
        // if (this.desktopStatus == true) {
        //   window.dfPcDesltop.finisLoad(); // 关闭loading效果
        // }
        this.getBusinessInfo();
      });
      this.isRouterAlice = false;
      this.$nextTick(function () {
        this.isRouterAlice = true;
      });
    },
    // 调用公共组件--赋值
    getDeadlineData(list) {
      this.form = list;
    },
    // 获取商家信息
    getBusinessInfo() {
      getAccountMsg().then((res) => {
        if (res.code == 0) {
          // res.data.passDayCount = -1
          if (res.data.passDayCount > 30) {
            this.deadlineStatus = false;
          } else if (res.data.passDayCount < 0) {
            this.deadlineStatus = false;
            this.form.diglogStatus = true;
          } else {
            this.deadlineStatus = true;
          }
          window.sessionStorage.deadlineStatus = this.deadlineStatus ? 'true' : 'false';
          this.form.days = res.data.passDayCount;
          this.form.url = res.data.assetUrl;
          this.onresize();
        } else {
          // console.log(res);
        }
      });
    },
    // 账号还有不到30天就过期，点击跳转到立即续费页面
    jumpRenew() {
      window.open(window.sessionStorage.setUrl4Pay);
    },
    changeDls() {
      this.deadlineStatus = false;
      this.onresize();
    },
    // 监听window高度
    onresize() {
      const wh = window.innerHeight;
      this.height = {
        height: `${wh}px`
      };
      this.width = {
        width: `${window.innerWidth}px`,
        height: `${wh}px`
      };
      if (this.deadlineStatus) {
        this.contentHeight = {
          height: `${wh - 146}px`,
          padding: '15px 0'
        };
      } else {
        this.contentHeight = {
          height: `${wh - 70}px`,
          padding: '15px 0'
        };
      }
      this.minHeight = {
        minHeight:
          `${wh
          - document.querySelectorAll('#yzTop')[0].offsetHeight
          - 140
          }px`
      };
    },
    // 点击查看评价
    lookCommentList() {
      // this.$emit('lookCommentList',0)
      this.commentNum = 0;
      this.$router.push({
        name: 'stage-commentList'
      });
    },
    // 点击查看公告栏
    lookBulletinBoard() {
      this.bulletinNum = 0;
      this.$router.push({
        name: 'stage-bulletinBoard'
      });
    }
  }
};
</script>

<style>
.maskOne {
  position: fixed;
  top: 0;
  left: 0;
  width: 145px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
}
.maskTwo {
  position: fixed;
  top: 0;
  right: 0;
  width: calc(100vw - 145px);
  height: 103px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
}
.maskThree {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 21px;
  height: calc(100vh - 103px);
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
}
.Aloading {
  position: absolute;
  left: 40%;
  top: 30%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
.LoadNone {
  display: none;
}
.conent {
  position: relative;
  overflow: hidden;
}
.left {
  background-color: #313131;
  height: inherit;
  box-sizing: border-box;
  width: 140px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 2000;
  background-position: 100% 100%;
}
.right {
  padding-left: 140px;
}
.right .top .el-tabs__header {
  margin: 0 !important;
}
.right-content {
  overflow: hidden;
  overflow-y: auto;
  margin-right: -16px;
  margin-left: -16px;
  padding-top: 15px;
}
.right-content > div {
  margin: 0 36px;
  width: calc(100vw - 166px);
}
.right-content2 {
  overflow: hidden;
  overflow-y: auto;
  margin-right: -16px;
  margin-left: -16px;
  padding-top: 15px;
}
.right-content2 > div {
  margin: 10px 46px;
  width: calc(100vw - 125px);
}
/* ::-webkit-scrollbar {
    display: none;
} */
.topMenuIcon {
  position: absolute !important;
  top: 14px !important;
  left: 155px;
  font-size: 22px;
  cursor: pointer;
}
.topMenuIcon2 {
  position: absolute !important;
  top: 14px !important;
  left: 95px;
  font-size: 22px;
  cursor: pointer;
}
.top_90 {
  top: 90px !important;
}
.desktopLeft {
  background-color: #fff;
  background-image: none !important;
  box-shadow: 0 0 38px -15px rgba(0, 0, 0, 0.2);
  border-right: 1px solid #eee;
}
.menuWidth1 {
  width: 65px !important;
}
.menuWidth2 {
  width: 125px !important;
}
.menuPL1 {
  padding-left: 65px !important;
}
.menuPL2 {
  padding-left: 125px !important;
}
</style>

<style lang="less" scoped>
.deadline {
  height: 48px;
  padding: 14px 30px;
  .d_left {
    float: left;
    p {
      height: 24px;
      line-height: 16px;
      font-size: 13px;
      color: #99a9bf;
      a {
        padding-left: 30px;
        text-decoration: none;
      }
    }
  }
  .d_right {
    float: left;
    .btn {
      height: 38px !important;
    }
  }
  i {
    float: right;
    cursor: pointer;
  }
}
.enlargeModel {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
  .container {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    border: 0;
    -webkit-transform: translateY(-60px);
    -moz-transform: translateY(-60px);
    -ms-transform: translateY(-60px);
    -o-transform: translateY(-60px);
    transform: translateY(-60px);
    -webkit-backface-visibility: hidden;
    -webkit-transition-property: -webkit-transform;
    -moz-transition-property: -moz-transform;
    transition-property: transform;
    -webkit-transition-duration: 0.3s;
    -moz-transition-duration: 0.3s;
    -ms-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    img {
      width: 500px;
      height: 500px;
      margin: -251px 0 0 -251px;
    }
  }
}
.is-visible {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s;
  .container {
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
